import React, {Component} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Container, Col, Row, Button} from "react-bootstrap";

import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";

//sweet alert
import swal from "sweetalert";

//jquery
import $ from "jquery";
import {OPEN_LOGIN_POPUP} from "../store/user/types";

const Banner = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const userType = localStorage.getItem("type");
  const isAuth = localStorage.getItem("isAuth");

  const handleClick = () => {
    !isAuth
      ? dispatch({type: OPEN_LOGIN_POPUP})
      : userType === "interviewee"
      ? history.push("/schedule")
      : swal({
          title: "Oops!",
          text: "You are not Interviewee!",
          icon: "info",
        });
  };
  return (
    <Container className="my-3 hash" id="banner">
      <Row>
        <Col sm={1}></Col>

        <Col
          sm={5}
          className="text-center text-md-left mt-5 mx-4"
          style={{"text-align": "left"}}
        >
          <h1>Here Comes the PrepWithMock!!!</h1>
          <h4 className="text-muted mt-4">
            The best and most efficient way to prepare for your upcoming
            technical interviews. Helps you prepare for every level of technical
            interviews
          </h4>
          {/* <a href="#contact"> */}
          <Button variant="dark" className="my-4" onClick={handleClick}>
            Try It Out
          </Button>
          {/* </a> */}
        </Col>

        <Col sm={5} className="p-5 mt-5" style={{align: "right"}}>
          <img alt="" src="/interview.png" width="100%" className="mx-auto)" />
        </Col>
      </Row>
    </Container>
  );
};

export default Banner;
